__turbopack_context__.v({
  "card_slide_flex": "CardSlideFlex-module-scss-module__XQa53q__card_slide_flex",
  "card_slide_flex_badge": "CardSlideFlex-module-scss-module__XQa53q__card_slide_flex_badge",
  "card_slide_flex_content": "CardSlideFlex-module-scss-module__XQa53q__card_slide_flex_content",
  "card_slide_flex_image_area": "CardSlideFlex-module-scss-module__XQa53q__card_slide_flex_image_area",
  "card_slide_flex_note": "CardSlideFlex-module-scss-module__XQa53q__card_slide_flex_note",
  "card_slide_flex_primary": "CardSlideFlex-module-scss-module__XQa53q__card_slide_flex_primary",
  "card_slide_flex_secondary": "CardSlideFlex-module-scss-module__XQa53q__card_slide_flex_secondary",
  "card_slide_flex_text": "CardSlideFlex-module-scss-module__XQa53q__card_slide_flex_text",
  "card_slide_flex_title": "CardSlideFlex-module-scss-module__XQa53q__card_slide_flex_title",
});
